(() => {
  class PdlOosOrder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';
      this.section = this.closest('.shopify-section, dialog');
      this.section?.addEventListener('variant:update', this.handleVariantUpdate);
    }

    disconnectedCallback() {
      this.section?.removeEventListener('variant:update', this.handleVariantUpdate);
    }

    handleVariantUpdate = (event) => {
      const html = event.detail?.data?.html;
      if (!html) return;
      const next = html.querySelector(`pdl-oos-order[data-block-id="${this.dataset.blockId}"]`);
      if (next) this.replaceWith(next.cloneNode(true));
    };
  }

  if (!customElements.get('pdl-oos-order')) {
    customElements.define('pdl-oos-order', PdlOosOrder);
  }
})();
